<template>
  <template v-if="variants.v1 === variant">
    <section data-anim-wrap class="pageHeader -type-1">
      <div data-anim-child="fade delay-1" class="pageHeader__image">
        <img
          :src="isMobileDevice ? vars.mobileBackgroundImage || vars.backgroundImage : vars.backgroundImage"
          alt="image"
        />
      </div>

      <div class="container">
        <h1 v-if="vars.titleText" data-anim-child="slide-up delay-1" class="pageHeader__title tw-text-white">
          {{ vars.titleText }}
        </h1>
        <div v-if="vars.titleHtml" v-html="vars.titleHtml" class="pageHeader__title" />

        <div v-if="descriptions" class="tw-space-y-1">
          <p
            v-for="({ description }, index) in descriptions"
            :key="`takeaction-description-${index}`"
            class="tw-max-w-2xl"
            :style="`${vars.textColor ? `color: var(--c-${vars.textColor}) !important` : ''}`"
          >
            {{ description }}
          </p>
        </div>

        <div v-if="buttons.length" class="tw-my-6 tw-flex tw-flex-wrap tw-justify-start tw-gap-2">
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`takeaction-button-${index}`"
            :to="button.link"
            :class="`n-${button.type} tw-w-full md:tw-w-auto`"
            :external="true"
            >{{ button.label }}</nuxt-link
          >
        </div>
      </div>
    </section>
  </template>

   <template v-if="variants.v2 === variant">
 
  <section data-anim-wrap class="pageHeader -type-1 tw-relative tw-h-[90vh] md:tw-h-[80vh]">
  
    <div data-anim-child="fade delay-1" class="pageHeader__image tw-absolute tw-inset-0 tw-bg-black">
      <img
        :src="isMobileDevice ? vars.mobileBackgroundImage || vars.backgroundImage : vars.backgroundImage"
        alt="image"
        class="tw-w-full tw-h-full tw-object-contain" 
      />
    </div>

    
    <div
      class="container tw-absolute tw-inset-x-0 tw-bottom-0 tw-flex tw-flex-col tw-items-start tw-text-left tw-pb-10 md:tw-pb-14"
    >
      <h1 v-if="vars.titleText" data-anim-child="slide-up delay-1" class="pageHeader__title tw-text-white">
        {{ vars.titleText }}
      </h1>
      <div v-if="vars.titleHtml" v-html="vars.titleHtml" class="pageHeader__title tw-text-left" />

      <div v-if="descriptions" class="tw-space-y-1">
        <p
          v-for="({ description }, index) in descriptions"
          :key="`takeaction-description-${index}`"
          class="tw-max-w-2xl"
          :style="`${vars.textColor ? `color: var(--c-${vars.textColor}) !important` : ''}`"
        >
          {{ description }}
        </p>
      </div>

      <div v-if="buttons.length" class="tw-my-6 tw-flex tw-flex-wrap tw-justify-start tw-gap-2">
        <nuxt-link
          v-for="(button, index) in buttons"
          :key="`takeaction-button-${index}`"
          :to="button.link"
          :class="`n-${button.type} tw-w-full md:tw-w-auto`"
          :external="true"
        >{{ button.label }}</nuxt-link>
      </div>
    </div>
  </section>
</template>

  <template v-else-if="variants.v4 === version">
    <section data-anim-wrap class="pageHeader -type-1 tw-min-h-[70vh]">
      <div data-anim-child="fade delay-1" class="pageHeader__image">
        <img
          :src="
            isMobileDevice ? variables.mobileBackgroundImage || variables.backgroundImage : variables.backgroundImage
          "
          alt="image"
        />
      </div>

      <div class="container">
        <h1 v-if="variables.mainTitleText" data-anim-child="slide-up delay-1" class="pageHeader__title">
          {{ variables.mainTitleText }}
        </h1>
        <div
          v-else-if="variables.mainTitleHtml"
          v-html="variables.mainTitleHtml"
          data-anim-child="slide-up delay-1"
          class="pageHeader__title"
        />
        <div
          data-anim-child="slide-up delay-2"
          class="pageHeader-nav tw-absolute tw-bottom-12 tw-z-10 tw-flex tw-flex-col tw-gap-4"
        >
          <div>
            <h5 v-if="variables.descriptionText" data-anim-child="slide-up delay-2">{{ variables.descriptionText }}</h5>
          </div>
          <div class="tw-flex tw-gap-4 lg:tw-gap-10">
            <template v-if="variables.buttonTypeText === 'standard'">
              <nuxt-link
                v-for="(tab, index) in tabs"
                :key="`knowledge-hub-tab-${index}`"
                :class="activeTab === tab.name ? 'n-primary' : 'n-secondary'"
                :to="`/knowledge-hub/${tab.name}`"
                :external="true"
                style="text-transform: uppercase; text-align: center; font-weight: bold"
                class="tw-col-span-6 tw-px-4 tw-py-6 lg:tw-col-span-2"
              >
                {{ tab.title }}
              </nuxt-link>
            </template>
            <template v-else>
              <nuxt-link
                v-for="(tab, index) in tabs"
                :key="`knowledge-hub-tab-${index}`"
                :class="activeTab === tab.name ? 'n-primary-link-btn' : 'n-primary-link-btn-disabled'"
                :to="`/knowledge-hub/${tab.name}`"
                :external="true"
                style="text-transform: uppercase; text-align: center; font-weight: bold"
                class="n-link tw-col-span-6 tw-px-4 tw-py-6 lg:tw-col-span-2"
              >
                {{ tab.title }}
              </nuxt-link>
            </template>
          </div>
        </div>
      </div>
    </section>
  </template>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'IntroSection',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v4: 'v4',
        v2: 'v2',
      },
    };
  },

  props: {
    version: {
      type: String,
      required: false,
    },
    variables: {
      type: Object,
      required: false,
    },
    tabs: {
      type: Array,
      required: false,
    },
    activeTab: {
      type: String,
      required: false,
    },
  },

  computed: {
    descriptions(): Array<{ description: string }> {
      return this.groupedVariables?.descriptions || [];
    },
    buttons(): Array<{ link: string; type: string; label: string }> {
      return this.groupedVariables?.buttons || [];
    },
  },
});
</script>
